<template>
    <div class="block block-bordered">
        <div class="block-header block-header-default">
            <div class="block-title">
                <h2 class="content-heading">Callback URL Settings</h2>
            </div>
        </div>
        <div class="block-content">
            <form v-on:submit="saveForm()">
                <div class="col-lg-12 col-xl-5 col-sm-12">
                    <p style="display: none;">{{ callback_url = getSafe(() => pgSetting.public_key) }}</p>

                    <div class="block block-rounded block-themed" v-if="!isHidden">
                        <div class="block-header bg-primary-darker">
                            <h3 class="block-title">My Callback URL </h3>
                            <div class="block-options ">
                                <button type="button" class="btn-block-option">
                                    <i class="si si-key"></i>
                                </button>
                            </div>
                        </div>
                        <div class="block-content bg-gray-light">
                            <p class="p-3 bg-gray-light text-gray-darker">{{ callback_url }}</p>
                        </div>
                    </div>

                    <div class="form-group" v-if="!isHidden && !edit" v-on:click="edit = true">
                        <button type="button" class="btn btn-hero-success">Edit My Public Callback URL</button>
                    </div>

                    <div class="form-group" v-if="!isHidden && edit">
                        <label for="example-textarea-input">Edit My Public Key</label>
                        <textarea class="form-control" id="example-textarea-input" v-model="settings.callback_url"
                                  name="example-textarea-input"
                                  rows="4" placeholder="https://www.callback-url.com"></textarea>
                    </div>

                    <p style="display: none;">{{ settings.project = getSafe(() => this.$route.params.project) }}</p>
                    <input type="hidden" id="project" v-model="settings.project">

                    <div class="form-group" v-if="!isHidden && edit">
                        <button type="submit" class="btn btn-hero-primary">Save My Callback URL</button>
                    </div>

                    <div class="form-group">
                        <button v-if="isHidden" v-on:click="reveal" type="button"
                                class="btn btn-outline-secondary mr-1 mb-3"><i class="fa fa-fw fa-eye mr-1"></i> Show
                            My Callback URL
                        </button>
                        <button v-if="!isHidden" v-on:click="hide" type="button"
                                class="btn btn-outline-secondary mr-1 mb-3"><i class="fa fa-fw fa-eye-slash mr-1"></i>
                            Hide My Callback URL
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CallbackSettings",
        data: function () {
            return {
                isHidden: true,
                edit: false,
                callback_url: 'Loading your Callback URL...',
                settings: {
                    public_key: '',
                    project: '',
                }
            }
        },
        created() {
            console.log("Slug " + this.$route.params.project);
            this.$store.dispatch('loadSettingCallback', {
                project: this.$route.params.project,
            });
        },
        computed: {
            pgSetting() {
                return this.$store.getters.getPgSettingCallback;
            },
        },
        methods: {
            saveForm() {
                event.preventDefault();
                this.$store.dispatch('createPGSettingCallback', {
                    settings: this.settings,
                });
            }, getSafe(fn) {
                try {
                    return fn();
                } catch (e) {
                    return undefined;
                }
            },
            reveal: function (event) {
                this.isHidden = false;
                this.edit = false;
            },
            hide: function (event) {
                this.isHidden = true;
                this.edit = false;
            }
        },

    }
</script>

<style scoped>

</style>
